export default __webpack_public_path__ + "static/media/blue-lines-bg-bottom.5b781f9d.png";